<template>
  <AmStatusModal />
</template>

<script setup>
import AmStatusModal from '@/components/molecules/AmStatusModal/AmStatusModal.vue'
</script>